import React from 'react'
import BestOrthopaedickarishnanagar from "../images/DR. SANKAR ROY ortho.jpg";
import ConsultantOrthopaedicsurgeonwestbengal from "../images/spinesurgeykrishnanagarnadia.jpg";

function Slider() {
  return (
    <div>
        <div id="carouselExampleIndicators" className="carousel slide" data-bs-ride="carousel">
  <div className="carousel-indicators">
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
  </div>
  <div className="carousel-inner">
    <div className="carousel-item active">
      <img src={BestOrthopaedickarishnanagar} className="d-block w-100" alt="BestOrthopaedickarishnanagar"/>
    </div>
    <div className="carousel-item">
      <a href='tel: +91 8759503787 '>
      <img src={ConsultantOrthopaedicsurgeonwestbengal} className="d-block w-100" alt="Consultant-Orthopaedic-surgeon-westbengal"/>
      </a>
    </div>
 
  </div>
  <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Previous</span>
  </button>
  <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
    <span className="carousel-control-next-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Next</span>
  </button>
</div>
    </div>
  )
}

export default Slider